import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '../../hooks/redux';

const GuestOnlyRoute: FC = () => {
  const { userInfo } = useAppSelector(state => state.auth);

  return userInfo ? (
    <Navigate
      to="/profile"
      replace
    />
  ) : (
    <Outlet />
  );
};

export default GuestOnlyRoute;
